import {
  Injectable, Provider, Type,
} from '@angular/core'
import { Subject } from 'rxjs'

export function provideRegionSelectIntl(intl: Type<RegionSelectIntl>): Provider {
  return {
    provide: RegionSelectIntl,
    useClass: intl,
  }
}

@Injectable({ providedIn: 'root' })
export class RegionSelectIntl {
  public readonly changes$ = new Subject<void>()

  public modalHeading = 'Region and language selection'

  public regionSelectLabel = 'Region'

  public languageSelectLabel = 'Language'

  public submitButtonLabel = 'Continue'

  public openButtonLabel = 'Open region and language selection'

  public closeButtonLabel = 'Close'

  public languageIsRequiredError = 'Required field'

  public noSelectedLanguageOptionLabel = 'Choose a language'
}
